import { Stack, Typography, styled } from "@mui/material"
import {
  AchievementBadge,
  isDefined,
  pluralize,
  useAchievementColor,
} from "@pharmupp/p3-front-commons"

interface ProgressGoalCardProps {
  cardNumber?: number
  actCount: number
  isChecked: boolean
}

export const ProgressGoalCard = ({
  cardNumber,
  actCount,
  isChecked,
}: ProgressGoalCardProps) => {
  return (
    <Stack gap={1} flex={1} px={1.25} alignItems={"center"}>
      <GoalTitle>
        {isDefined(cardNumber) &&
          `${cardNumber}${pluralize(cardNumber, "er", "ème")} `}
        palier
      </GoalTitle>
      <GoalActCount>
        {actCount} {pluralize(actCount, "acte", "actes")}
      </GoalActCount>
      <GoalCheck isChecked={isChecked} />
    </Stack>
  )
}

const GoalCheck = ({ isChecked }: { isChecked: boolean }) => {
  const { bgColor } = useAchievementColor(isChecked)
  const label = isChecked ? "Atteint" : "En attente"

  return (
    <GoalCheckContainer bgColor={bgColor}>
      <AchievementBadge isAchieved={isChecked} />
      <GoalCheckLabel>{label}</GoalCheckLabel>
    </GoalCheckContainer>
  )
}

const GoalCheckContainer = styled(Stack, {
  shouldForwardProp: (props) => props !== "bgColor",
})<{ bgColor: string }>(({ theme, bgColor }) => ({
  flexDirection: "row",
  alignItems: "center",
  gap: theme.spacing(0.5),
  backgroundColor: bgColor,
  borderRadius: "100px",
  padding: theme.spacing(0.5),
  paddingRight: theme.spacing(1.25),
}))
const GoalCheckLabel = styled(Typography)(({ theme }) => ({
  color: theme.palette.common.darkBlue,
  textWrap: "nowrap",
  fontWeight: 400,
}))
GoalCheckLabel.defaultProps = {
  variant: "14px",
}

const GoalTitle = styled(Typography)(({ theme }) => ({
  textTransform: "uppercase",
  color: theme.palette.branding.light3,
}))
GoalTitle.defaultProps = {
  variant: "10px",
}

const GoalActCount = styled(Typography)(({ theme }) => ({
  color: theme.palette.common.black,
  fontWeight: 600,
}))
GoalActCount.defaultProps = {
  variant: "12px",
}
